export const workOrderResourceGuard = 'GET /work-orders/d+';
